import mixins from 'vue-typed-mixins';

import { BannerInterface } from '@/interfaces/BannerInterface';
import { HeaderInfo } from '@/interfaces/HeaderInfo';
import { PersonalOfferProduct } from '@/interfaces/PersonalOfferProduct';
import i18n from '@/plugins/i18n/i18n';
import analytics from '@/services/analytics';
import axiosInstance from '@/services/axios';
import bannerService from '@/services/banner-service';
import { eventBus } from '@/services/event-bus';
import { interactsNavigation } from '@/services/mixins/interacts-navigation';
import notification from '@/services/notification';
import apiUrls from '@/shared/api-urls';
import { constants } from '@/shared/constants';
import { PersonalOfferCategoryType } from '@/shared/enums/PersonalOfferCategoryType';
import { UserEventsTypes } from '@/shared/enums/UserEventsTypes';
import { isEmpty } from '@/shared/helpers';

export const personalOffer = mixins().extend({
	mixins: [ interactsNavigation ],
	data() {
		return {
			banner: {} as BannerInterface,
			personalOfferBanner: {} as BannerInterface,
			refs: constants.modals as { [key: string]: string },
			selectedCategoryName: '' as string,
			topupUrl: constants.globalUrls.personalOfferTopup,
			selectedProduct: {} as PersonalOfferProduct,
			userEventsTypes: UserEventsTypes,
			personalOfferEventType: constants.eventsTypes.updatePersonalOffer,
			eventsTypes: constants.eventsTypes,
			serviceType: '',
		};
	},
	computed: {
		isCategoryActivatedByEmail(): Function {
			return (categoryName: string) => {
				return categoryName === PersonalOfferCategoryType.prepaid2Postpaid
					|| categoryName === PersonalOfferCategoryType.contractRenewal
					|| categoryName === PersonalOfferCategoryType.recommendedTariff;
			};
		},
		addonTitle(): Function {
			return (product: PersonalOfferProduct) => `${ product.additionalProductTitle ? product.additionalProductTitle + '+' : '' }${ product.title }`;
		},
		buttonLabel(): Function {
			return (categoryName: string) => {
				if (categoryName === PersonalOfferCategoryType.addons || categoryName === PersonalOfferCategoryType.topup)
					return i18n.t('message.common.button.activate');
				if (this.isCategoryActivatedByEmail(categoryName))
					return i18n.t('message.personalOffer.sendRequestButton');
				return '';
			};
		},
		serviceTypeInfo(): string {
			return this.serviceType;
		},
		isPersonalOffer(): boolean {
			return !isEmpty(this.personalOfferBanner);
		},
		customBanner(): BannerInterface {
			return this.isPersonalOffer ? this.personalOfferBanner : this.banner;
		},
	},
	methods: {
		getServiceType(headerInfo: HeaderInfo): void {
			this.serviceType = headerInfo.type;
			eventBus.$emit(this.personalOfferEventType);
		},
		selectProduct(product: PersonalOfferProduct, categoryName: string): void {
			this.selectedProduct = product;
			this.selectedCategoryName = categoryName;
			this.userEvent(this.userEventsTypes.clicked);

			if (categoryName === PersonalOfferCategoryType.topup)
				location.href = this.topupUrl;
			if (categoryName === PersonalOfferCategoryType.addons)
				this.openModal(this.refs.personalOfferAddon);
			if (this.isCategoryActivatedByEmail(categoryName))
				this.activateAddon();
		},
		activateAddon(): void {
			const data = {
				subscriberIdentity: (this as any).subscriberIdentity,
				category: this.selectedCategoryName,
				offerId: this.selectedProduct.offerId,
				title: this.addonTitle(this.selectedProduct)
			};

			axiosInstance
				.post(apiUrls.activatePersonalOfferProduct.url, data)
				.then(() => {
					if (this.selectedCategoryName === PersonalOfferCategoryType.addons) {
						const tPrefix = 'message.personalOffer.successNotification';
						notification.success(i18n.t(`${ tPrefix }.title`), i18n.t(`${ tPrefix }.description`));
					}

					if (this.isCategoryActivatedByEmail(this.selectedCategoryName))
						this.openModal(this.refs.personalOfferPre2Post);

					eventBus.$emit(this.personalOfferEventType);

					if (this.selectedCategoryName === PersonalOfferCategoryType.addons)
						this.userEvent(this.userEventsTypes.activated);
				});
		},
		userEvent(type: string): void {
			const data = {
				subscriberIdentity: (this as any).subscriberIdentity,
				event: type,
				offerId: this.selectedProduct.offerId,
				responseTrackingCode: this.selectedProduct.responseTrackingCode,
				treatmentTrackingCode: this.selectedProduct.treatmentTrackingCode
			};

			axiosInstance.post(apiUrls.userEvent.url, data);
		},
		openModal(modalType: string): void {
			(this as any).$refs[modalType].toggleModal();
		},
		getPersonalOfferBanner(subscriberIdentity: string): void {
			bannerService.getPersonalOfferBanner(subscriberIdentity, this.serviceTypeInfo).then((banner: BannerInterface) => {
				if (!isEmpty(banner)) {
					this.personalOfferBanner = banner;
					this.personalOfferBanner.cssClass = 'banner--personal-offer';
					this.personalOfferBanner.buttonLabel = this.buttonLabel(this.personalOfferBanner.personalOfferCategory.name);
				}
			});
		},
		showActivatePersonalOfferModal() {
			analytics.onBannerClick(this.personalOfferBanner.personalOfferCategory.name);
			(this as any).$refs[this.refs.offerActivationModal].selectProduct(this.personalOfferBanner.personalOfferCategory.items[0], this.personalOfferBanner.personalOfferCategory.name);
		}
	},
});
